<template>
  <div>
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" style="width:200px;margin-right:10px;" clearable placeholder="学生姓名"></el-input>
        <el-input @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" style="width:200px;margin-right:10px;" clearable placeholder="证件号"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="add()" type="primary" style="margin-right: 0px;">
          新增白名单
        </el-button>
      </div>
    </div>
    <div ref="identityPage" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="examineeName" label="姓名">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye2">
              <span>{{scope.row.examineeName}}</span>
              <i v-if="scope.row.examineeName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye2">
              <span>{{scope.row.examineeName2}}</span>
              <i v-if="scope.row.examineeName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye">
              <span>{{scope.row.examineeIdNo}}</span>
              <i v-if="scope.row.examineeIdNo" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye">
              <span>{{scope.row.examineeIdNo2}}</span>
              <i v-if="scope.row.examineeIdNo2" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="add(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" style="color: #E91212;" @click="del(scope.row)"> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog :title="(editForm.dataId?'编辑':'新增')+editForm.title" v-if="editForm.show" :visible.sync="editForm.show" width="500px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './white-list-edit'
export default {
  name: 'identityCheck',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { subjectName: '', batchId: this.$route.query.batchId, whiteType: 0 },
      page: { pageSize: 20, pageNum: 1 },
      batchList: [],
      editForm: { show: false, row: null, title: '白名单' },
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['identityPage'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiWhiteList.getPage(this.queryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'examineeIdNo2', el.examineeIdNo)
            this.$set(el, 'examineeName2', el.examineeName)
            this.$set(el, 'trueEye2', true)
            this.$set(el, 'trueEye', true)
            if (el.examineeIdNo) {
              el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            }
            if (el.examineeName) {
              el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            }
          })
        }
        this.page = page
        this.editForm.show = false;
        this.editForm.row = null
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadIdNo (index, row) {
      if (row.trueEye == true) {
        this.$set(row, 'trueEye', false)
      } else {
        this.$set(row, 'trueEye', true)
      }
    },
    async reloadName (index, row) {
      if (row.trueEye2 == true) {
        this.$set(row, 'trueEye2', false)
      } else {
        this.$set(row, 'trueEye2', true)
      }
    },
    async add (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async del (row) {
      try {
        let confirm = await this.$confirm('删除后将无法恢复，确定要删除该记录吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiWhiteList.del(row.whiteId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e);
      }
    }
  }
}
</script>
